module.exports = __webpack_public_path__ + "img/nostromo 5 balcone.0e72af14.jpeg";